<template>
  <div>
    <div class="container px-6 mt-16">
      <h1 class="text-lg pl-0 md:pl-6 font-bold"><span class="text-pink-500">4.</span>
        {{ $t('messages.step_four.title') }}
      </h1>
      <p class="mt-4 px-0 md:px-6 font-semibold">
        {{ $t('messages.step_four.description') }}
      </p>
      <div class="flex mt-6 flex-wrap px-0 md:px-6">
        <div class="w-full">
          <h1 class="uppercase text-lg font-bold">{{ $t('messages.step_four.instructions') }}</h1>
          <div class="mt-6 text-gray-700">
            <p>- {{ $t('messages.step_four.instruction_12') }}</p>
            <p>- {{ $t('messages.step_four.instruction_1') }}</p>
            <p>- {{ $t('messages.step_four.instruction_2') }}</p>
            <p>- {{ $t('messages.step_four.instruction_3') }}</p>
            <p>- {{ $t('messages.step_four.instruction_4') }}</p>
            <p>- {{ $t('messages.step_four.instruction_5') }}</p>
            <p>- {{ $t('messages.step_four.instruction_6') }}</p>
            <p>- {{ $t('messages.step_four.instruction_7') }}</p>
            <p>- {{ $t('messages.step_four.instruction_8') }}</p>
            <p>- {{ $t('messages.step_four.instruction_9') }}</p>
            <p>- {{ $t('messages.step_four.instruction_10') }}</p>
            <p>- {{ $t('messages.step_four.instruction_11') }}</p>
          </div>
          <div class="w-full h-auto	bg-grey-500 mt-8 flex ">
            <vue-dropzone
              class="w-full flex flex-wrap items-center justify-center bg-grey-500"
              ref="myVueDropzone"
              id="dropzone"
              :options="dropzoneOptions"
              :useCustomSlot="true"
              :duplicateCheck="true"
              @vdropzone-error="onPhotoUploadError"
              @vdropzone-file-added="checkTotalPhotos"
              @vdropzone-success="checkTotalPhotos"
              @vdropzone-removed-file="checkTotalPhotos"
            >
              <div class="dropzone-custom-content bg-transparent">
                <h3 class="dropzone-custom-title bg-pink-500 py-4 text-white">{{ $t('messages.photos.first_message') }}</h3>
                <div class="subtitle text-gray-600">{{ $t('messages.photos.second_message') }}</div>
              </div>
            </vue-dropzone>
          </div>
        </div>
        <p v-if="validationError" class="text-red-600 text-sm w-full text-center">{{ $t("messages.profile.photos.validation_error") }}</p>
        <p v-if="uploadError" class="text-red-600 text-sm w-full text-center">{{ $t("messages.profile.photos.upload_error") }}</p>
      </div>
    </div>

    <transition name="modal">
      <div v-if="isCropping">
        <div
          class="overlay h-full w-full flex justify-center items-center z-50"
          @click.self="isOpenMaxFileExceeded = false"
        >
          <div
            class="modal p-6 bg-white rounded-lg mx-auto my-0 flex flex-col justify-center items-center"
          >
            <div class="img-cropper">
              <div class="w-full flex flex-col sm:flex-row justify-center items-center">
                <div>
                  <a
                    href="#"
                    @click.prevent="cropImage"
                    class="mx-4 no-underline mb-2 sm:mb-0 text-white font-semibold rounded px-3 py-2 inline-flex bg-pink-500 border hover:text-pink-500 hover:bg-white hover:border-pink-500"
                  >{{ $t("messages.profile.photos.max_file_exceeded.accept") }}</a>
                </div>
              </div>
            <vue-cropper
              ref="cropper"
              :src="toCropImage"
              alt="Source Image"
              :aspectRatio="1 / 1"
              :dragMode="'move'"
              :cropBoxMovable="true"
              :cropBoxResizable="true"
              :minCropBoxWidth="100"
              :minCropBoxHeight="100"
            >
            </vue-cropper>
            <div class="w-full flex flex-col sm:flex-row justify-center items-center">
              <div>
                <a
                  href="#"
                  @click.prevent="cropImage"
                  class="mx-4 no-underline mb-2 sm:mb-0 text-white font-semibold rounded px-3 py-2 inline-flex bg-pink-500 border hover:text-pink-500 hover:bg-white hover:border-pink-500"
                >{{ $t("messages.profile.photos.max_file_exceeded.accept") }}</a>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { v4 as uuidv1 } from 'uuid';

import firebase from "firebase/app";
import "firebase/storage";

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

import Compressor from 'compressorjs';

import bus from "@/bus";

export default {
  name: "RegisterStepFour",
  components: {
    vueDropzone: vue2Dropzone,
    VueCropper
  },
  data: function() {
    return {
      foto: [],
      isCropping: false,
      toCropImage: null,
      cropImg: null,
      validationError: false,
      uploadError: false,
      dropzoneOptions: {
        url: '/api/web/temp-post',
        withCredentials: true,
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        thumbnailWidth: 150,
        maxFilesize: 12,
        addRemoveLinks: true,
        maxFiles: 10,
        timeout: 3000000,
        uploadMultiple: false,
        duplicateCheck: true,
        transformFile: async (file, done) => {
          if (file.dropped) {
              done(file);
              return;
            }

          this.isCropping = true;
          this.toCropImage = URL.createObjectURL(file);

          bus.$on("was-cropped", async () => {
             if (file.dropped) {
                done(file);
              }

              if (!file.dropped) {
                this.$refs.myVueDropzone.removeFile(file);
                const format = file.type;

                await this.cropImg.toBlob(async (blob) => {
                  await new Compressor(blob, {
                    quality: 0.6,
                    success: (result) => {
                      result.dropped = true;
                      result.lastModifiedDate = 1581465610000;
                      result.name = `newUserImage.${format[1]}`;

                      this.$refs.myVueDropzone.addFile(result);
                      done(result);
                      this.isCropping = false;
                    },
                    error(err) {
                      console.log(err.message);
                    },
                  });
              });
              }
          });
        }
      }
    };
  },
  mounted() {
    bus.$on('user-no-photos', type => {
      switch(type) {
        case 'empty':
          this.validationError = true;
          this.uploadError = false;
        break;
        case 'error':
          this.uploadError = true;
          this.validationError = false;
        break;
      }
    })
  },
  methods: {
    onPhotoUploadError(file) {
      this.$refs.myVueDropzone.removeFile(file);
      this.checkTotalPhotos();
      /*this.$toasted.show(this.$t('messages.step_six.images.file_upload_error'), {
        type: 'error',
        duration: 3000,
        position: 'bottom-right',
      });*/
    },
    checkTotalPhotos() {
      let images = this.$refs.myVueDropzone.getAcceptedFiles();

      this.validationError = false;
      bus.$emit('uploaded-photos', images);
    },
    async getData(des = '') {
      let images = this.$refs.myVueDropzone.getAcceptedFiles();

      return images.map(async image => {
        let name = image.name;
        let ext = name.split(".");
        ext = name[1];
        let lafoto = "";
        let logoName = `${uuidv1()}.${ext}`;
        let logo = await firebase
          .storage()
          .ref(`profile/${logoName}`)
          .put(image);
        lafoto = await logo.ref.getDownloadURL();

        return {
          url: lafoto
        };
      });

      return await Promise.all(imgs).then(pics => {
        return pics;
      })
    },
    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas();
      this.isCropping = false;

      bus.$emit("was-cropped");
    }
  }
};
</script>
<style scoped>
#dropzone >>> .dz-message {
  display: flex !important;
  justify-content: center !important;
  width: 100% !important;
}

.img-cropper {
  max-height: 600px;
  max-width: 500px;
  overflow: hidden;
}
</style>
<style lang="scss" scoped>
#dropzone {
  background-color: #f6f6f6 !important;
  .dz-message {
    padding: 10px;
    background-color: transparent;
    color: #444444;
    font-weight: 600;
  }
}
</style>
